// src/pages/Terms.tsx
import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen p-8 bg-secondary text-offwhite max-w-3xl mx-auto space-y-6">
      <Link to="/runtime" className="block mb-4 text-teal hover:underline">
        ← Back to Runtime
      </Link>
      <h1 className="text-3xl font-semibold">Terms &amp; Conditions</h1>

      <p>Last updated: June 8, 2025</p>

      <section>
        <h2 className="text-2xl font-semibold mb-2">1. Acceptance of Terms</h2>
        <p>
          By accessing or using CortexRuntime (“the Service”), you agree to be
          bound by these Terms &amp; Conditions.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">2. User Obligations</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>No illegal or harmful use.</li>
          <li>Respect copyright and intellectual property.</li>
          <li>You are responsible for your account security.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">
          3. Subscription &amp; Payments
        </h2>
        <p>
          The Pro plan is a one-time fee of $15 (ZAR 275) for lifetime access.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">4. Account Termination</h2>
        <p>
          We reserve the right to suspend or terminate accounts for violations
          of these Terms.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">
          5. Disclaimers &amp; Liability
        </h2>
        <p>
          The Service is provided “as is.” We are not liable for indirect or
          consequential damages.
        </p>
      </section>

      {/* <section>
        <h2 className="text-2xl font-semibold mb-2">6. Governing Law</h2>
        <p>These Terms are governed by the laws of South Africa.</p>
      </section> */}

      <section>
        <h2 className="text-2xl font-semibold mb-2">7. Contact</h2>
        <p>
          For questions about these Terms, please{" "}
          <Link to="/contact" className="text-teal hover:underline">
            contact us
          </Link>
          .
        </p>
      </section>
    </div>
  );
}
